<template>
    <form class="form-contact-call" action="" method="POST" @submit.prevent="submit" novalidate autocomplete="off">
        <div>
            <figure>
                <img loading="lazy" src="imgs/web/radka_lg.webp" srcset="imgs/web/radka_lg.webp 1x, imgs/web/radka_lg@2x.webp 2x" alt="">
            </figure>

            <div class="form-wrapper">
                <form-input-type-phone-number
                    name="phone"
                    label="Telefonnummer"
                    phoneCountry="de"
                    :errors="errors.phone"
                    full-border
                    required
                ></form-input-type-phone-number>

                <form-input-type-select
                    name="call"
                    label="Wählen Sie Ihr Anliegen aus"
                    :options="selectOptions"
                    :errors="errors.call"
                    full-border
                    required
                ></form-input-type-select>

                <v-button type="submit" label="Rufen Sie mich bitte an" icon="material-symbols-rounded.phone" full-width></v-button>
            </div>
        </div>        

        <p class="new-text-sm text-color-default text-centered">Wir verarbeiten die Daten in Übereinstimmung mit der <a href="/datenschutzerklarung">Richtlinie zur Verarbeitung personenbezogener Daten</a> zum Zweck eines einmaligen telefonischen Kontakts mit Informationen über unsere Dienstleistungen.</p>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                errors: {}
            }
        },
        computed: {
            selectOptions() {
                return [
                    { label: 'Ich habe eine allgemeine Frage zu Vitadio' },
                    { label: 'Mein Code funktioniert nicht' },
                    { label: 'Ich kann mich nicht einloggen' },
                    { label: 'Ich kann mein Rezept nicht hochladen' },
                    { label: 'Die Verifizierungs-SMS ist nicht angekommen' },
                    { label: 'Sonstiges' }
                ]
            },
        },
        methods: {
            submit() {
                let formData = {}

                $(this.$el)
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData[name] = value
                    })

                axios
                    .post('api/ask-for-call', formData, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        window.location.href = '/call-success'
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            }
        }
    }
</script>
